import {
  DEFAULT_LOCALE,
  isSupportedLocale,
  LOCALE_ALIASES,
  type Locale,
} from '../i18n/locales'

/**
 * Resolve a BCP-47 / i18next language tag to a supported Locale.
 * Unknown tags fall back to DEFAULT_LOCALE.
 */
export function normalizeLocale(lang: string): Locale {
  const primary = lang.split(/[-_]/)[0]?.toLowerCase() ?? ''
  const resolved = (LOCALE_ALIASES[primary] ?? primary) as Locale
  return isSupportedLocale(resolved) ? resolved : DEFAULT_LOCALE
}

/**
 * Whether locale-gated content may be shown for the active UI language.
 * `undefined` / empty `allowed` = available in all locales (Open/Closed for future clips).
 */
export function isContentLocaleAllowed(
  allowed: readonly Locale[] | undefined,
  lang: string,
): boolean {
  if (!allowed?.length) return true
  return allowed.includes(normalizeLocale(lang))
}
